<!-- Same as src/components/forms/CustomTextarea.vue but without token validation -->

<template>
  <MAFieldWrapper
    :id="id"
    :type="type"
    :label="label"
    :value="input"
    :disabled="disabled"
    :required="required"
    :readonly="readonly"
    :placeholder="placeholder"
    :rules="rules"
  >
    <template #default="{ validator, handleBlur }">
      <component
        :is="TextareaVariant"
        :id="id"
        v-model="input"
        :auto-resize="autoResize"
        :type="type"
        :rows="rows"
        :cols="cols"
        :autofocus="autofocus"
        :invalid="validator?.$dirty && validator?.$invalid"
        :disabled="disabled"
        :placeholder="placeholder"
        :class="[customClass]"
        @blur="onBlur(handleBlur)"
      />
    </template>
  </MAFieldWrapper>
</template>

<script setup lang="ts">
import MAFieldWrapper from "@/components/primevueComponents/MAFieldWrapper.vue";
import Textarea from "@/volt/Textarea.vue";
import SoftTextarea from "@/volt/SoftTextarea.vue";
import { ulid } from "ulid";

const props = withDefaults(
  defineProps<{
    type?: "email" | "text" | "phone";
    label?: string;
    id?: string;
    modelValue?: string;
    disabled?: boolean;
    required?: boolean;
    autofocus?: boolean;
    readonly?: boolean;
    placeholder?: string;
    autoResize?: boolean;
    rules?: Record<string, any>;
    rows?: number;
    cols?: number;
    customClass?: string;
    maxTokenLength?: number;
    variant?: "default" | "soft";
  }>(),
  {
    id: ulid(),
    disabled: false,
    placeholder: "",
    modelValue: "",
    autoResize: true,
    type: "text",
    rules: () => ({}),
    customClass: "",
    variant: "default",
  }
);

const TextareaVariant = computed(() => {
  return props.variant === "soft" ? SoftTextarea : Textarea;
});

const emit = defineEmits(["update:modelValue", "blur"]);
const input = useVModel(props, "modelValue", emit);

function onBlur(cb: () => void) {
  if (cb) cb();
  emit("blur");
}
</script>
